import React from 'react';
import { ChevronLeft, ChevronRight, MoreHorizontal } from 'lucide-react';

const Pagination = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
  showInfo = true,
}) => {
  const getVisiblePages = () => {
    const delta = 2;
    const range = [];
    const rangeWithDots = [];

    for (let i = Math.max(2, currentPage - delta); i <= Math.min(totalPages - 1, currentPage + delta); i++) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      rangeWithDots.push(1, '...');
    } else {
      rangeWithDots.push(1);
    }

    rangeWithDots.push(...range);

    if (currentPage + delta < totalPages - 1) {
      rangeWithDots.push('...', totalPages);
    } else {
      rangeWithDots.push(totalPages);
    }

    return rangeWithDots;
  };

  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  if (totalPages <= 1) return null;

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 px-6 py-4 border-t border-moss/10 bg-surface-muted">
      {showInfo && (
        <div className="text-sm font-medium text-pakistan/60">
          Showing <span className="font-bold text-pakistan">{startItem}</span> to{' '}
          <span className="font-bold text-pakistan">{endItem}</span> of{' '}
          <span className="font-bold text-pakistan">{totalItems}</span> results
        </div>
      )}

      <div className="flex items-center gap-1.5">
        <button
          type="button"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`ui-btn px-3 py-2 rounded-xl text-sm ${
            currentPage === 1
              ? 'text-pakistan/25 cursor-not-allowed'
              : 'text-pakistan/70 hover:bg-white/60 hover:shadow-sm border border-transparent hover:border-moss/20'
          }`}
        >
          <ChevronLeft size={16} />
          Previous
        </button>

        <div className="flex items-center gap-1">
          {getVisiblePages().map((page, index) => (
            <React.Fragment key={index}>
              {page === '...' ? (
                <div className="flex items-center justify-center w-9 h-9">
                  <MoreHorizontal size={16} className="text-moss/40" />
                </div>
              ) : (
                <button
                  type="button"
                  onClick={() => onPageChange(page)}
                  className={`w-9 h-9 rounded-xl text-sm font-bold transition-all duration-200 ${
                    currentPage === page
                      ? 'text-white shadow-glow'
                      : 'text-pakistan/70 hover:bg-white/60 hover:shadow-sm border border-transparent hover:border-moss/20'
                  }`}
                  style={currentPage === page ? { background: 'linear-gradient(135deg, #BC6C25, #606C38)' } : undefined}
                >
                  {page}
                </button>
              )}
            </React.Fragment>
          ))}
        </div>

        <button
          type="button"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`ui-btn px-3 py-2 rounded-xl text-sm ${
            currentPage === totalPages
              ? 'text-pakistan/25 cursor-not-allowed'
              : 'text-pakistan/70 hover:bg-white/60 hover:shadow-sm border border-transparent hover:border-moss/20'
          }`}
        >
          Next
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
